// extracted by mini-css-extract-plugin
module.exports = {"tabCardContainer":"DescriptionAndDisclosureContent_tabCardContainer__29i96"};